<template>
  <div class="page1" v-if="!showIframe">
    <!-- 헤더 -->
    <header class="header1">
      <!-- <div class="logo">
        <img src="/assets/images/common/ArtnerConsulting_logo_ai.png" alt="Artner Consulting" />
      </div> -->
    </header>

    <!-- 메인 -->
    <main class="main1">
      <div  class="hero-block">
        <p class="main-title">
          <span style="color: #004aa1;">내부감사</span>·<span style="color: #4dac3b;">내부통제</span> 지능형 진단·평가·점검 시스템
        </p>

        <div class="agrid-logo">
          <img src="/assets/images/common/AGRIDIQ 1.png" alt="AGRID IQ" />
        </div>
      </div>

      <div class="signup-buttons">

        <!-- 감사인 역량진단 -->
        <div class="tile">

          <div class="item1">
            <div class="tile-logo">
              <img src="/assets/images/common/main_ace_logo2.png" alt="ACE" />
            </div>
            <p class="label">감사인 역량진단</p>
            <button class="signup-button green" @click="goAce">바로가기</button>
          </div>
        </div>

        <!-- 내부감사 품질평가 -->
        <div class="tile">

          <div class="item1">
            <div class="tile-logo">
              <img src="/assets/images/common/main_ezqar_logo2.png" alt="EZQAR" />
            </div>
            <p class="label">내부감사 품질평가</p>
            <button class="signup-button blue" @click="goToEvaluatorSignup">바로가기</button>
          </div>
        </div>

        <!-- 내부통제 경영인증 -->
        <div class="tile">

          <div class="item1">
            <div class="tile-logo">
              <img src="/assets/images/common/main_ezims_logo2.png" alt="EZIMS" />
            </div>
            <!-- <p class="label">내부통제 경영인증</p> -->
            <p class="label">내부통제 평가</p>
            <button class="signup-button purple" @click="goToEzIms">바로가기</button>
          </div>
        </div>

        <!-- 내부통제 자가점검 -->
        <div class="tile">

          <div class="item1">
            <div class="tile-logo">
              <img src="/assets/images/common/main_pcow_logo.png" alt="PCOW" />
            </div>
            <p class="label">내부통제 자율점검</p>
            <button class="signup-button dark" @click="goToPcow">바로가기</button>
          </div>
        </div>

      </div>
    </main>

    <!-- 푸터 -->
    <!-- <footer class="footer1">
      <div>
        <p style="font-weight: 700;">08506 서울시 금천구 가산디지털2로 108, 905호(가산동, 뉴티캐슬)</p>
      </div>
      <div>Copyright by 2026 아트너컨설팅. All Right Reserved.</div>
    </footer> -->
    <!-- 푸터 -->
    <footer class="footer1">
      <div class="footer-inner">

        <div class="footer-logo">
          <img src="/assets/images/common/ArtnerConsulting_logo_ai.png" alt="Artner Consulting" />
        </div>

        <div class="footer-text">
          <p style="font-weight: 700;">
            08506 서울시 금천구 가산디지털2로 108, 905호(가산동, 뉴티캐슬)
          </p>
          <div>Copyright by 2026 아트너컨설팅. All Right Reserved.</div>
        </div>

      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const showIframe = ref(false)

const goAce = () => {
  window.location.href = 'https://ace.ezqar.com'
}

const goToEzIms = () => {
  window.location.href = 'https://ezims.ezqar.com'
}

const goToPcow = () => {
  window.location.href = 'https://pcow.ezqar.com'
}

const goToEvaluatorSignup = async () => {
  router.push({ name: 'login' })
}
</script>
<style scoped>
/* .page1 {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
} */

.page1 {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 헤더 */
.logo img {
  width: 150px;
  height: auto;
}

/* .header1 {
  padding: 30px;
} */

.header1 {
  padding: clamp(16px, 2vw, 50px);
}

/* 메인 */
/* .main1 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  flex-direction: column;
} */

/* 메인 */
.main1 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  width: 100%;
  padding-left: 40px;
  padding-right: 40px;

  /* 화면 높이에 따라 자연스럽게 변하는 상하 여백 */
  /* padding-top: clamp(12px, 2vh, 36px);
  padding-bottom: clamp(24px, 4vh, 64px); */
}

/* ✅ 문구(타이틀/서브타이틀 추천 스타일) */
/* .main-title {
  font-size: 2.2rem;
  font-weight: 700;
  letter-spacing: 2px;
  color: #595959;
  margin: 0;
  text-align: center;
} */

/* 타이틀 + 로고 영역 */
.hero-block {
  display: flex;
  flex-direction: column;
  align-items: center;

  /* 카드 영역과의 간격 */
  margin-bottom: clamp(28px, 7vh, 72px);
}

.main-title {
  font-size: clamp(1.5rem, 2.2vw, 2.2rem);
  font-weight: 700;
  letter-spacing: 2px;
  color: #595959;
  margin: 0;
  text-align: center;
  line-height: 1.4;
}

.main-sub {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.85);
  text-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
  margin: 0 0 18px;
}

/* 그리드 */
/* .signup-buttons {
  width: 100%;
  max-width: 1100px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
} */

/* 카드 영역 */
.signup-buttons {
  width: 100%;
  max-width: 1100px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;

  /* 푸터와의 간격 */
  margin-bottom: clamp(28px, 5vh, 72px);
}

/* 로고 + 카드 묶음 */
.tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.tile-logo {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.tile-logo img {
  max-height: 70px;
  max-width: 180px;
  width: auto;
  height: auto;
  display: block;
  object-fit: contain;
}

/* 카드 */
.item1 {
  width: 100%;
  background: #ffffff;
  border-radius: 18px;
  border: 2px solid #595959;
  padding: 28px 20px;
  text-align: center;
  /* box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06); */
  transition: transform 0.2s ease;
}

.item1:hover {
  transform: translateY(-4px);
}

.label {
  margin-bottom: 16px;
  font-size: 1.4rem;
  font-weight: 700;
  color: #222;
}

/* 버튼 */
.signup-button {
  width: 100%;
  height: 52px;
  border: none;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #fff;
}

.green {
  background: linear-gradient(135deg, #27ae60, #2ecc71);
}

.green:hover {
  background: linear-gradient(135deg, #219150, #27ae60);
}

.blue {
  background: linear-gradient(135deg, #1976d2, #2196f3);
}

.blue:hover {
  background: linear-gradient(135deg, #1565c0, #1e88e5);
}

.purple {
  background: linear-gradient(135deg, #6c5ce7, #8e44ad);
}

.purple:hover {
  background: linear-gradient(135deg, #5a4bd6, #7d3c98);
}

.dark {
  background: linear-gradient(135deg, #2c3e50, #34495e);
}

.dark:hover {
  background: linear-gradient(135deg, #1f2f3d, #2c3e50);
}

/* 푸터 */
.footer1 {
  margin-top: auto;
  text-align: center;
  padding: 0px 10px;
  /* margin: 0 10px; */
  font-size: 13px;
  color: rgba(99, 99, 99, 0.75);
  /* text-shadow: 0 6px 18px rgba(0,0,0,0.35); */
  background: transparent;
}

.footer-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 0px 20px;
  gap: 24px;
}

.footer-logo img {
  width: 120px;
  height: auto;
}

.footer-text {
  text-align: left;
}

/* .agrid-logo {
  display: flex;
  justify-content: center;
  margin: 10px 0px 50px;
}

.agrid-logo img {
  width: 800px;
  height: auto;
} */

.agrid-logo {
  display: flex;
  justify-content: center;

  /* 타이틀과 로고 사이 간격 */
  margin-top: clamp(10px, 1.5vh, 18px);
}

.agrid-logo img {
  width: min(800px, 78vw);
  height: auto;
  display: block;
}

/* 반응형 */
@media (max-width: 1100px) {
  .signup-buttons {
    grid-template-columns: repeat(2, 1fr);
  }

  .header1 {
    padding: 100px 60px;
  }
}

@media (max-width: 600px) {
  .signup-buttons {
    grid-template-columns: 1fr;
  }

  .header1 {
    padding: 80px 24px;
  }

  .main-title {
    font-size: 1.6rem;
  }
}

.tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.tile-logo {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.tile-logo img {
  max-height: 70px;
  max-width: 180px;
  width: auto;
  height: auto;
  display: block;
  object-fit: contain;
}

.item1 {
  width: 100%;
  background: #ffffff;
  border-radius: 18px;
  border: 2px solid #595959;
  padding: 28px 20px;
  text-align: center;
  transition: transform 0.2s ease;
}

.item1:hover {
  transform: translateY(-4px);
}

.label {
  margin-bottom: 16px;
  font-size: 1.4rem;
  font-weight: 700;
  color: #222;
}

.signup-button {
  width: 100%;
  height: 52px;
  border: none;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #fff;
}

.green { background: linear-gradient(135deg, #27ae60, #2ecc71); }
.green:hover { background: linear-gradient(135deg, #219150, #27ae60); }

.blue { background: linear-gradient(135deg, #1976d2, #2196f3); }
.blue:hover { background: linear-gradient(135deg, #1565c0, #1e88e5); }

.purple { background: linear-gradient(135deg, #6c5ce7, #8e44ad); }
.purple:hover { background: linear-gradient(135deg, #5a4bd6, #7d3c98); }

.dark { background: linear-gradient(135deg, #2c3e50, #34495e); }
.dark:hover { background: linear-gradient(135deg, #1f2f3d, #2c3e50); }

/* 푸터 */
.footer1 {
  text-align: center;
  /* padding: clamp(16px, 2vh, 24px) 20px; */
  font-size: 13px;
  color: rgba(99, 99, 99, 0.75);
  background: transparent;

  /* 핵심: auto 제거 */
  margin-top: auto;
}

.footer-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.footer-logo img {
  width: 120px;
  height: auto;
}

.footer-text {
  text-align: left;
}
</style>
